export function AdminFooter() {
  return (
    <div className=' flex justify-between p-[16px] font-semibold  text-[12.8px] bg-[#F5F7FA] w-full border-t border-t-black/25 text-black content_body_footer'>
      <h2>Powered By © INFITIC</h2>
      <h4>...</h4>
    </div>
  )
} 